<div class="date-time-picker">
  <input [formControl]="control" placeholder="{{'None' | translate}}" class="form-control" bsDateTimePicker [control]="control">
  <button class="btn btn-clear-date" *ngIf="control?.value"><span class="material-icons-outlined h-100 d-block" [title]="'Clear all' | translate"
      (click)="clearDateInput()">
      close
    </span></button>
</div>
